import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../_metronic/assets/ts/components'
import {KTIcon, initialQueryState} from '../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'

const Filter = () => {
  const {updateState} = useQueryRequest()
  const [approvalStatus, setApprovalStatus] = useState<string | undefined>()
  const [status, setStatus] = useState<string | undefined>()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    setApprovalStatus(undefined)
    setStatus(undefined)
    updateState({filter: undefined, ...initialQueryState})
  }

  const filterData = () => {
    updateState({
      filter: {approvalStatus, status},
      ...initialQueryState,
    })
  }

  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={false}
        type='button'
        className='btn btn-light-primary me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTIcon iconName='filter' className='fs-2' />
        Filter
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div className='menu menu-sub menu-sub-dropdown w-300px w-md-325px' data-kt-menu='true'>
        {/* begin::Header */}
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          {/* begin::Input group - Approval Status */}
          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Approval Status:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='approval-status'
              data-hide-search='true'
              onChange={(e) => setApprovalStatus(e.target.value)}
              value={approvalStatus}
            >
              <option value=''>All</option>
              <option value='Pending'>Pending</option>
              <option value='Approved'>Approved</option>
              <option value='Rejected'>Rejected</option>
            </select>
          </div>
          {/* end::Input group */}

          {/* begin::Input group - Post Status */}
          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Post Status:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-kt-user-table-filter='status'
              data-hide-search='true'
              onChange={(e) => setStatus(e.target.value)}
              value={status}
            >
              <option value=''>All</option>
              <option value='Active'>Active</option>
              <option value='Inactive'>Inactive</option>
              <option value='Sold'>Sold</option>
              <option value='Expired'>Expired</option>
            </select>
          </div>
          {/* end::Input group */}

          {/* begin::Input group - Trash Filter */}
          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Select Trashed Records:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              data-kt-select2='true'
              data-placeholder='Select option'
              data-allow-clear='true'
              data-hide-search='true'
              onChange={(e) => {
                // This will be handled by QueryRequestProvider
                updateState({
                  filter: {
                    approvalStatus,
                    status,
                    trashedStatus: e.target.value !== 'without_trash' ? e.target.value : '',
                  },
                })
              }}
              defaultValue='without_trash'
            >
              <option value='without_trash'>Without Trashed</option>
              <option value='with_trashed'>With Trashed</option>
              <option value='trashed'>Only Trashed</option>
            </select>
          </div>
          {/* end::Input group */}

          {/* begin::Actions */}
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={false}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>
            <button
              disabled={false}
              type='button'
              onClick={filterData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export {Filter}
